import { render, staticRenderFns } from "./_VNavigation.vue?vue&type=template&id=1ca8e088&scoped=true&"
import script from "./_VNavigation.vue?vue&type=script&lang=js&"
export * from "./_VNavigation.vue?vue&type=script&lang=js&"
import style0 from "./_VNavigation.vue?vue&type=style&index=0&id=1ca8e088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca8e088",
  null
  
)

export default component.exports